<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'flowmap',
  components: {
  },
  data() {
    return {
      appname: '',
      //item 当前点击按钮信息
      //this.$store.state.detailInfo  当前数据信息
      //this.$store.state.childrensInfo  子表数据
      // 1.从this.$route取app  appid  查询是否有流程 -->  查询当前责任人
      // this.$store.state.detailInfo     gysxxAppStatus  :  0  可编辑    1  只读   
    }
  },
  methods: {
    //判断当前应用是否有流程
    ishasFlow(loadingObj) {
      this.getViewPople(loadingObj);
    },
    //获取当前责任人
    getViewPople(loadingObj) {
      this.appname = this.$route.params.app;
      console.log('APP name:' + this.appname)
      //判断流程是否启动
      //0:流程未启动。1:流程进行中。2:流程已结束。3:当前流程执行人。4不是当前流程执行人 （3和4流程都未结束）
      var url = Config.dev_url + '/api-apps/customization/' + this.appname + '/flow/workStatus/' + this.$store.state.detailInfo.id;
      this.$axios.get(url, {}).then((res) => {
        if (res.data.code == 0) {
          //正常返回
          var returncode = res.data.data;
          if (returncode == 3) {
            //当前流程执行人
            //驳回单据
            if (this.$store.state.detailInfo.state == '0') {
              //判断当前登录人是否是单据创建人
              if (this.$store.state.detailInfo.createuser == this.$store.state.currentuser.id) {
                //驳回可编辑
                this.$set(this.$store.state.detailInfo, 'flowState', 2)
              } else {
                this.$set(this.$store.state.detailInfo, 'flowState', 1)//不可编辑
              }
              this.$set(this.$store.state.detailInfo, 'editState', 1)//不可编辑
            } else {
              if (this.appname == 'defectreportApp') { //缺陷提报
                if (this.$store.state.detailInfo.state == '1') {
                  this.$set(this.$store.state.detailInfo, 'editState', 2)
                  this.$set(this.$store.state.detailInfo, 'flowState', 1)
                } else {
                  this.$set(this.$store.state.detailInfo, 'editState', 1)
                  this.$set(this.$store.state.detailInfo, 'flowState', 1)
                }
              } else {
                this.$set(this.$store.state.detailInfo, 'flowState', 1)
              }
            }
          } else if (returncode == 4 || returncode == 2) {
            //不是当前的流程执行人 或者
            //流程已结束
            if (this.appname == 'defectreportApp') { //缺陷提报
              if (this.$store.state.detailInfo.state == '1') {
                this.$set(this.$store.state.detailInfo, 'editState', 2)
                this.$set(this.$store.state.detailInfo, 'flowState', 1)
              } else {
                this.$set(this.$store.state.detailInfo, 'editState', 1)
                this.$set(this.$store.state.detailInfo, 'flowState', 1)
              }
            }
          } else if (returncode == 1) {
            //流程进行中
            //判断当前登录人是否是单据创建人
            if (this.$store.state.detailInfo.createuser != this.$store.state.currentuser.id) {
              //单据的创建人不是当前的登录人
              //流程未启动非创建人不可编辑
              this.$set(this.$store.state.detailInfo, 'flowState', 1)
            } else {
              //创建人是当前的登录人
              //流程未启动创建人可编辑
              this.$set(this.$store.state.detailInfo, 'flowState', 2)
            }
            //流程已经启动，不可以编辑
            if (this.appname == 'defectreportApp') { //缺陷提报
              if (this.$store.state.detailInfo.state == '1') {
                this.$set(this.$store.state.detailInfo, 'editState', 2)
              } else {
                this.$set(this.$store.state.detailInfo, 'editState', 1)
              }
            }
          }
          loadingObj.loading = false;
          this.$store.state.jsonData.list[0].model = this.$store.state.jsonData.list[0].columns[0].label;
        }
      });
    },
  }
}
</script>

<style>
</style>
